export const INIT = 'init';
export const LOADING = 'loading';
export const DONE = 'done';
export const ERROR = 'error';

export default function labelOf(fieldId) {
    return fieldId;
}